
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[[...skus]]",
      function () {
        return require("private-next-pages/shop/[[...skus]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[[...skus]]"])
      });
    }
  